import { IEntityDto } from "./base";

export interface IValueTemplate extends IEntityDto {
  key: string;
  content: string;
}
